import FetchClient from "./FetchClient";

function setZipSearchBtn() {
  const btn = document.getElementById('zip-search-btn'),
    zip = document.getElementById('zip'),
    prefecture = document.getElementById('prefecture'),
    city = document.getElementById('city');
  if (!btn || !zip || !prefecture || !city) return false;

  const api = new FetchClient();

  const setAddress = async () => {
    const zipCode = zip.value.replace(/[ー－−―‐-]/g, '').replace(/[^\d]/g, '');
    if (zipCode.length !== 7) {
      alert('郵便番号を正しく入力してください');
      return;
    }

    btn.disabled = true;

    const res = await api.get(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`);
    if (res === 'FAILED') {
      alert('通信に失敗しました。');
    } else {
      const data = res.results[0];
      prefecture.value = data.address1;
      city.value = data.address2 + data.address3;
    }

    btn.disabled = false;
  }

  btn.addEventListener('click', () => setAddress())
}


function setDropzone() {
  const dropzone = document.getElementById('dropzone');
  const fileInput = document.getElementById('file');
  const error = document.getElementById('error-message');
  const text = document.getElementById('dropzone-text');

  if (!dropzone || !fileInput || !error || !text) return;

  const allowedExtensions = ['.xlsx', '.xls', '.docx', '.doc', '.pdf', '.zip'];
  const maxSizeMB = 5;
  const maxTotalSizeMB = 10;

  dropzone.addEventListener('click', (e) => {
    e.preventDefault();
    fileInput.click();
  });

  dropzone.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropzone.classList.add('hover');
  });

  dropzone.addEventListener('dragleave', () => {
    dropzone.classList.remove('hover');
  });

  dropzone.addEventListener('drop', (e) => {
    e.preventDefault();
    dropzone.classList.remove('hover');
    handleFiles(e.dataTransfer.files);
  });

  fileInput.addEventListener('change', () => {
    handleFiles(fileInput.files);
  });


  function handleFiles(fileList) {
    const files = Array.from(fileList);
    const errors = [];

    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    const maxTotalBytes = maxTotalSizeMB * 1024 * 1024;

    if (totalSize > maxTotalBytes) {
      showErrors([
        `合計ファイルサイズが ${maxTotalSizeMB}MB を超えています（現在 ${(totalSize / 1024 / 1024).toFixed(2)}MB）`
      ]);
      return;
    }

    let filesCount = 0;

    files.forEach((file) => {
      const validation = validateFile(file);

      if (!validation.valid) {
        errors.push(validation.message);
        return;
      }

      filesCount++;

      if (filesCount == 1) {
        text.innerHTML = `${file.name}<br>`;
      } else {
        text.innerHTML += `${file.name}<br>`;
      }

    });

    showErrors(errors);
  }

  function validateFile(file) {
    const ext = getExtension(file.name);
    const isAllowed = allowedExtensions.includes(ext);
    const isSizeOk = file.size <= maxSizeMB * 1024 * 1024;

    if (!isAllowed) {
      return {
        valid: false,
        message: `${file.name}：許可されていない形式です`,
      };
    }

    if (!isSizeOk) {
      return {
        valid: false,
        message: `${file.name}：サイズが ${maxSizeMB}MB を超えています`,
      };
    }

    return { valid: true };
  }

  function getExtension(filename) {
    return '.' + filename.split('.').pop().toLowerCase();
  }

  function showErrors(messages) {
    error.innerHTML = messages.length
      ? messages.join('<br>')
      : '';
  }
}


function setAgreeCheck() {
  const check = document.getElementById('agree-check'),
    btn = document.getElementById('submit-btn');

  if (!check || !btn) return false;

  const setBtnStatus = () => {
    btn.disabled = !check.checked;
  }

  setBtnStatus();
  check.addEventListener('change', () => setBtnStatus())
}


const setForm = () => {
  const form = document.getElementById('contact-form');
  if (!form) return false;

  setZipSearchBtn();
  setDropzone();
  setAgreeCheck();
};

export default setForm;
